/**
 * Default maximum distance (in meters) for nearby payee lookups.
 * Payees with locations beyond this distance are not considered "nearby".
 */
export const DEFAULT_MAX_DISTANCE_METERS = 500;
